import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from "react";
import {
  IInfoPlanDevice,
  IClientInfo,
} from "../../provider/thaniacel.provider.interfaces";

interface IProps {
  children: ReactNode;
}

interface IAuthAgent {
  email: string;
  password: string;
}

type IContext = {
  step: number;
  user: IAuthAgent | null;
  client: IClientInfo | null;
  infoPlanDevice: IInfoPlanDevice | null;
  touchID: string | null;
  infoPayment: any;
  setStep: Dispatch<SetStateAction<number>>;
  setInfoPayment: Dispatch<SetStateAction<any>>;
  setUser: Dispatch<SetStateAction<IAuthAgent | null>>;
  setInfoPlanDevice: Dispatch<SetStateAction<IInfoPlanDevice | null>>;
  setClient: Dispatch<SetStateAction<IClientInfo | null>>;
  setTouchID: Dispatch<SetStateAction<string | null>>;
  handleInitialState: () => void;
};

export const CreateUsedThaniacelContext = React.createContext<IContext>(
  {} as IContext,
);
export const useCreateUsedThaniacelContext = () =>
  useContext<IContext>(CreateUsedThaniacelContext);

const CreateUsedThaniacelProvider = ({ children }: IProps) => {
  const [step, setStep] = useState<number>(1);
  const [user, setUser] = useState<IAuthAgent | null>(null);
  const [infoPlanDevice, setInfoPlanDevice] = useState<IInfoPlanDevice | null>(
    null,
  );
  const [touchID, setTouchID] = useState<string | null>(null);
  const [infoPayment, setInfoPayment] = useState<any>(null);
  const [client, setClient] = useState<IClientInfo | null>(null);
  const handleInitialState = () => {
    setStep(1);
    setUser(null);
    setInfoPlanDevice(null);
    setClient(null);
  };
  const context: IContext = useMemo(
    () => ({
      step,
      user,
      infoPlanDevice,
      client,
      touchID,
      infoPayment,
      setStep,
      setUser,
      setInfoPlanDevice,
      setClient,
      setTouchID,
      handleInitialState,
      setInfoPayment,
    }),
    [step, user, infoPlanDevice, client, touchID],
  );
  return (
    <CreateUsedThaniacelContext.Provider value={context}>
      {children}
    </CreateUsedThaniacelContext.Provider>
  );
};

export default CreateUsedThaniacelProvider;
